import { registerEnumType } from 'type-graphql'

export enum FeatureFlagKeyEnum {
  COMPLEX_EDITOR_LAYOUT = 'COMPLEX_EDITOR_LAYOUT',
  CUSTOMER_LAYOUT = 'CUSTOMER_LAYOUT',
}

registerEnumType(FeatureFlagKeyEnum, {
  name: 'FeatureFlagKeyEnum',
  description: 'Available feature flag keys',
})
